<template>
  <div class="vertical">
    <Profile :profile="resume.profile" />
    <div class="columns">
      <aside class="column">
        <Contact :contact="resume.contact" />
        <div class="line-horizontal-50"/>
        <Skills :skills="resume.skills" />
        <div class="line-horizontal-50"/>
        <Education :education="resume.education" />
      </aside>
      <div>
        <Experience :experience="resume.experience" />
      </div>
    </div>
  </div>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js + TypeScript App"/> -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HelloWorld from './components/HelloWorld.vue';
import Profile from './components/Profile.vue';
import Contact from './components/Contact.vue';
import Education from './components/Education.vue';
import Skills from './components/Skills.vue';
import Experience from './components/Experience.vue'

import ResumeLoader from './utilities/ResumeLoader';
import { ResumeProfile, ResumeContact, Resume } from './models/Resume';

export default defineComponent({
  name: 'App',
  components: {
    Profile,
    Contact,
    Education,
    Skills,
    Experience
  },
  data() {
    return {
      resume: ResumeLoader.load()
    }
  }
});

</script>

<style lang="stylus">

@import "~../src/styles/reset.css";
@import "~../src/styles/styles";

#app
  // font-family Avenir, Helvetica, Arial, sans-serif
  // -webkit-font-smoothing antialiased
  // -moz-osx-font-smoothing grayscale
  // text-align center
  // color #2c3e50
  // margin-top 60px

.vertical
  display flex
  flex-direction column
  gap spacing-48

.columns
  display flex
  gap: 48pt

aside
  width 144pt;
  flex-shrink: 0

.column
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: spacing-32;

</style>
